import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BrandDetailPage = lazy(() => import('../pages/brand/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/brands/:slug',
    element: <BrandDetailPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

export default routes;